import img1 from "@/image/home/brand/1-huawei.png";
import img2 from "@/image/home/brand/2-h3c.png";
import img3 from "@/image/home/brand/3-cisco.png";
import img4 from "@/image/home/brand/4-sundray.png";
import img5 from "@/image/home/brand/5-ibm.png";
import img6 from "@/image/home/brand/6-dell.png";
import img7 from "@/image/home/brand/7-inspur.png";
import img8 from "@/image/home/brand/8-juniper.png";
import img9 from "@/image/home/brand/9-ruijie.png";

import p1 from "@/image/home/partner/1-神州数码.png";
import p2 from "@/image/home/partner/2-联强国际.png";
import p3 from "@/image/home/partner/3-中建材.png";
import p4 from "@/image/home/partner/4-深业集团.png";
import p5 from "@/image/home/partner/5-恒大地产.png";
import p6 from "@/image/home/partner/6-国信证券.png";
import p7 from "@/image/home/partner/7-易宝软件.png";
import p8 from "@/image/home/partner/8-广田集团.png";
import p9 from "@/image/home/partner/9-中银国际.png";
import p10 from "@/image/home/partner/10-周大福.png";
import p11 from "@/image/home/partner/11-海外装饰.png";
import p12 from "@/image/home/partner/12-货拉拉.png";
import p13 from "@/image/home/partner/13-广宁.png";
import p14 from "@/image/home/partner/14-智宇实业.png";
import p15 from "@/image/home/partner/15-深圳中学.png";
import p16 from "@/image/home/partner/16-深圳实验.png";
import p17 from "@/image/home/partner/17-达实智能.png";
import p18 from "@/image/home/partner/18-迅龙创威.png";
import p19 from "@/image/home/partner/19-唯品会.png";
import p20 from "@/image/home/partner/20-mandarin.png";
import p21 from "@/image/home/partner/21-广州金领技工.png";

export let brand = [
  { url: img1 },
  { url: img2 },
  { url: img3 },
  { url: img4 },
  { url: img5 },
  { url: img6 },
  { url: img7 },
  { url: img8 },
  { url: img9 },
];

export let partner = [
  { url: p1 },
  { url: p2 },
  { url: p3 },
  { url: p4 },
  { url: p5 },
  { url: p6 },
  { url: p7 },
  { url: p8 },
  { url: p9 },
  { url: p10 },
  { url: p11 },
  { url: p12 },
  { url: p13 },
  { url: p14 },
  { url: p15 },
  { url: p16 },
  { url: p17 },
  { url: p18 },
  { url: p19 },
  { url: p20 },
  { url: p21 },
];
